import { CoverageApiService } from './service/CoverageApiService';

export const coverageApiService: CoverageApiService = new CoverageApiService();
